<script setup lang="ts">
/**
 * Pricing page in the template's inner-page rhythm: title band, plan cards on
 * the grey band, the plan comparison, why Premium, the dark text marquee,
 * FAQ and testimonials. MarketingFeaturePage adds the breadcrumb, the
 * cross-links, the closing CTA and all SEO meta and JSON-LD.
 */
definePageMeta({
  layout: false,
  auth: false,
})

// Its URL in Czech, German and Polish (constants/localizedRoutes.ts).
false && /*#__PURE__*/ defineI18nRoute({ paths: { cs: '/cenik', de: '/preise', pl: '/cennik' } })

const { t } = useI18n()

const sliderItems = computed(() =>
  (['builder', 'templates', 'online', 'letters'] as const).map(id =>
    t(`premium.pricingPage.slider.${id}`),
  ),
)
</script>

<template>
  <MarketingFeaturePage seo-key="pricing" path="/pricing" :breadcrumb-title="t('nav.pricing')">
    <SofaxPricingPlans />
    <LazyHomepageFeatureComparisonSection />
    <LazyHomepageSubscriptionBenefitsSection />
    <SofaxTextSlider :items="sliderItems" />
    <LazyHomepageFaqSection />
    <SofaxTestimonials />
  </MarketingFeaturePage>
</template>
